module.exports = __webpack_public_path__ + "img/cross.56c15449.svg";